module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1);
	var oauth_provider_1 = __webpack_require__(12);
	var access_token_provider_1 = __webpack_require__(13);
	/**
	 * Allows configuration of CoreSDK
	 * @export
	 * @class CoreSDKConfigurator
	 */
	var CoreSDKConfigurator = /** @class */ (function () {
	    function CoreSDKConfigurator() {
	    }
	    /**
	     * Set the WebAPI key.
	     * @param {string} webApiKey
	     * @returns {CoreSDKConfigurator}
	     *
	     * @memberOf CoreSDKConfigurator
	     */
	    CoreSDKConfigurator.prototype.useWebApiKey = function (webApiKey) {
	        exports.config.webApiKey = webApiKey;
	        return this;
	    };
	    /**
	     * Specifies the private key for CSCoreSDK request signing.
	     * @param {string} signingKey
	     * @returns {CoreSDKConfigurator}
	     *
	     * @memberOf CoreSDKConfigurator
	     */
	    CoreSDKConfigurator.prototype.useRequestSigning = function (signingKey) {
	        exports.config.signingKey = signingKey;
	        return this;
	    };
	    /**
	     * Set other then the default language cs-CZ.
	     * @param {string} language a language to be set
	     * @returns {CoreSDKConfigurator} reference for configuration chaining
	     *
	     * @memberOf CoreSDKConfigurator
	     */
	    CoreSDKConfigurator.prototype.useLanguage = function (language) {
	        exports.config.language = language;
	        return this;
	    };
	    /**
	     * Sets the environment which the SDK should use.
	     *
	     * @param {Environment} environment environment to use
	     * @returns {CoreSDKConfigurator} reference for configuration chaining
	     *
	     * @memberOf CoreSDKConfigurator
	     */
	    CoreSDKConfigurator.prototype.useEnvironment = function (environment) {
	        exports.config.environment = environment;
	        return this;
	    };
	    /**
	     * Sets the config for oAuth 2
	     *
	     * @param {Oauth2Config} oauth2 Oauth2Config to use
	     * @returns {CoreSDKConfigurator} reference for configuration chaining
	     *
	     * @memberOf CoreSDKConfigurator
	     */
	    CoreSDKConfigurator.prototype.useOauth2 = function (oauth2) {
	        exports.config.oauth2 = oauth2;
	        var accessTokenProvider = new access_token_provider_1.AccessTokenProvider(exports.config);
	        exports.sharedContext.accessTokenProvider = accessTokenProvider;
	        exports.sharedContext.oauthProvider = new oauth_provider_1.OauthProvider(accessTokenProvider, exports.config);
	        return this;
	    };
	    return CoreSDKConfigurator;
	}());
	exports.CoreSDKConfigurator = CoreSDKConfigurator;
	/**
	 * Shared WebApiConfiguration
	 */
	exports.config = new core_1.WebApiConfiguration();
	var configurator = new CoreSDKConfigurator();
	/**
	 * Internal structure to share information between different SDKs
	 */
	exports.sharedContext = new core_1.WebApiContext();
	/**
	 * Set the WebAPI key.
	 * @param {string} webApiKey
	 * @returns {CoreSDKConfigurator}
	 */
	exports.useWebApiKey = function (webApiKey) {
	    configurator.useWebApiKey(webApiKey);
	    return configurator;
	};
	/**
	 * Specifies the private key for CSCoreSDK request signing.
	 * @param {string} signingKey The private key to sign reguests.
	 * @returns {CoreSDKConfigurator} reference for configuration chaining.
	 */
	exports.useRequestSigning = function (signingKey) {
	    configurator.useRequestSigning(signingKey);
	    return configurator;
	};
	/**
	 *  Set other then the default language cs-CZ.
	 *  @param {string} language a language to be set.
	 *  @returns {CoreSDKConfigurator} reference for configuration chaining.
	 */
	exports.useLanguage = function (language) {
	    configurator.useLanguage(language);
	    return configurator;
	};
	/**
	 * Sets the environment which the SDK should use.
	 * @param {Environment} environment environment to use
	 * @returns {CoreSDKConfigurator} reference for configuration chaining.
	 */
	exports.useEnvironment = function (environment) {
	    configurator.useEnvironment(environment);
	    return configurator;
	};
	/**
	 * Sets the config for oAuth 2
	 * @param {Oauth2Config} oauth2 Oauth2Config to use
	 * @returns {CoreSDKConfigurator} reference for configuration chaining.
	 */
	exports.useOauth2 = function (oauth2) {
	    configurator.useOauth2(oauth2);
	    return configurator;
	};
	__export(__webpack_require__(1));
	__export(__webpack_require__(16));
	__export(__webpack_require__(24));
	__export(__webpack_require__(25));
	__export(__webpack_require__(26));


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(2));
	var web_api_configuration_1 = __webpack_require__(4);
	exports.WebApiConfiguration = web_api_configuration_1.WebApiConfiguration;
	var web_api_context_1 = __webpack_require__(6);
	exports.WebApiContext = web_api_context_1.WebApiContext;
	var environment_1 = __webpack_require__(5);
	exports.Environment = environment_1.Environment;
	var signer_1 = __webpack_require__(7);
	exports.Signer = signer_1.Signer;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var StandardError = __webpack_require__(3)
	
	/**
	 * Base error class
	 * @param {any} msg 
	 * @param {any} payload 
	 */
	function CSSDKError(msg, payload) {
	  if (!payload) {
	    payload = {}
	  }
	  StandardError.call(this, msg, payload)
	}
	
	CSSDKError.prototype = Object.create(StandardError.prototype, {
	  constructor: { value: CSSDKError, configurable: true, writable: true }
	})
	
	/**
	 * Error class thrown when communicating with API
	 * @param {any} msg 
	 * @param {any} payload 
	 */
	function WebApiError(msg, payload) {
	
	  StandardError.call(this, msg, payload)
	};
	
	WebApiError.prototype = Object.create(CSSDKError.prototype, {
	  constructor: { value: WebApiError, configurable: true, writable: true }
	});
	
	WebApiError.prototype.getStatusCode = function () {
	  return this.payload.statusCode;
	}
	
	/**
	 * Error class thrown when there is misconfiguration of SDK
	 * @param {any} msg 
	 * @param {any} payload 
	 */
	function ConfigurationError(msg, payload) {
	
	  StandardError.call(this, msg, payload)
	};
	
	ConfigurationError.prototype = Object.create(CSSDKError.prototype, {
	  constructor: { value: ConfigurationError, configurable: true, writable: true }
	});
	
	exports.CSSDKError = CSSDKError;
	exports.WebApiError = WebApiError;
	exports.ConfigurationError = ConfigurationError;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = require("standard-error");

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var environment_1 = __webpack_require__(5);
	/**
	 * Configuration of SDK
	 * @export
	 * @class WebApiConfiguration
	 */
	var WebApiConfiguration = /** @class */ (function () {
	    function WebApiConfiguration() {
	        /**
	         * Language to use. Defaults to 'cs-CZ'
	         */
	        this.language = 'cs-CZ';
	        /**
	         * Signing key for request signing. It is not set by default.
	         */
	        this.signingKey = null;
	        /**
	         * Environment to use. Default is Sandbox environment
	         */
	        this.environment = environment_1.Environment.Sandbox;
	        /**
	       * Oath2 configuration. It is not set by default.
	       */
	        this.oauth2 = null;
	    }
	    /**
	     * Copies the configuration.
	     * @returns {WebApiConfiguration}
	     *
	     * @memberOf WebApiConfiguration
	     */
	    WebApiConfiguration.prototype.copy = function () {
	        var newConfig = new WebApiConfiguration();
	        newConfig.webApiKey = this.webApiKey;
	        newConfig.language = this.language;
	        newConfig.signingKey = this.signingKey;
	        newConfig.environment = this.environment;
	        newConfig.oauth2 = this.oauth2;
	        return newConfig;
	    };
	    return WebApiConfiguration;
	}());
	exports.WebApiConfiguration = WebApiConfiguration;


/***/ }),
/* 5 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Environment object that specifies communication endpoints for the SDK
	 * @export
	 * @class Environment
	 */
	var Environment = /** @class */ (function () {
	    /**
	     * Creates new Environment instance
	     *
	     * @param apiContextBaseUrl Base URL path. Start of API context
	     * @param oAuth2ContextBaseUrl Base URL path for OAuth2 authentication.
	     */
	    function Environment(apiContextBaseUrl, oAuth2ContextBaseUrl) {
	        this.apiContextBaseUrl = apiContextBaseUrl;
	        this.oAuth2ContextBaseUrl = oAuth2ContextBaseUrl;
	    }
	    /**
	     * Sandbox environment. This is the default one. Use it for development.
	     */
	    Environment.Sandbox = new Environment("https://webapi.developers.erstegroup.com/api/csas/public/sandbox", "https://webapi.developers.erstegroup.com/api/csas/sandbox/v1/sandbox-idp");
	    /**
	     * Production environment of CSAS. Use it in production with production API Key.
	     */
	    Environment.Production = new Environment("https://www.csas.cz/webapi", "https://bezpecnost.csas.cz/mep/fs/fl/oauth2");
	    return Environment;
	}());
	exports.Environment = Environment;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var error_1 = __webpack_require__(2);
	/**
	 * @export
	 * @class WebApiContext
	 * @implements {AccessTokenProviderInterface}
	 * @implements {OathInterface}
	 */
	var WebApiContext = /** @class */ (function () {
	    function WebApiContext() {
	    }
	    /**
	     * Delegate getAccessToken call to accessTokenProvider if there is any
	     * @returns {Promise<AccessToken>}
	     *
	     * @memberOf WebApiContext
	     */
	    WebApiContext.prototype.getAccessToken = function () {
	        this._ensureRightConfiguration();
	        return this.accessTokenProvider.getAccessToken();
	    };
	    /**
	     * Delegate refreshAccessToken call to accessTokenProvider if there is any
	     * @returns {Promise<AccessToken>}
	     *
	     * @memberOf WebApiContext
	     */
	    WebApiContext.prototype.refreshAccessToken = function () {
	        this._ensureRightConfiguration();
	        return this.accessTokenProvider.refreshAccessToken();
	    };
	    /**
	   * Returns login url to CSAS MEP in string
	   * @returns {string}
	   *
	   * @memberOf WebApiContext
	   */
	    WebApiContext.prototype.getOauth2Url = function () {
	        return this.oauthProvider.getOauth2Url();
	    };
	    /**
	   * Extracts access token from redirect url and sets it on AccessTokenProvider
	   * @param {string} url
	   * @returns {Promise<AccessToken>}
	   *
	   * @memberOf WebApiContext
	   */
	    WebApiContext.prototype.processRedirect = function (url) {
	        return this.oauthProvider.processRedirect(url);
	    };
	    /**
	     * Set AccessToken on AccessTokenProvider
	     * @param {(AccessToken | string)} token
	     * @returns {void}
	     *
	     * @memberOf WebApiContext
	     */
	    WebApiContext.prototype.useAccessToken = function (token) {
	        return this.accessTokenProvider.useAccessToken(token);
	    };
	    /**
	     * Set code on accessTokenProvider that is used for retrieving access token if you are using Authorization Code grant type
	     * @param {string} code
	     * @returns {void}
	     *
	     * @memberOf WebApiContext
	     */
	    WebApiContext.prototype.useCode = function (code) {
	        this.accessTokenProvider.useCode(code);
	    };
	    /**
	   * Returns code on accessTokenProvider that is used for retrieving access token if you are using Authorization Code grant type
	   * @returns {string}
	   *
	   * @memberOf WebApiContext
	   */
	    WebApiContext.prototype.getCode = function () {
	        return this.accessTokenProvider.getCode();
	    };
	    /**
	     * Ensure that accessTokenProvider is set
	     * @private
	     * @returns {void}
	     *
	     * @memberOf WebApiContext
	     */
	    WebApiContext.prototype._ensureRightConfiguration = function () {
	        if (!this.accessTokenProvider) {
	            throw new error_1.ConfigurationError("AccessTokenProvider has to be set on SharedContext if you want to call SharedContext's methods");
	        }
	    };
	    return WebApiContext;
	}());
	exports.WebApiContext = WebApiContext;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var crypto_js_1 = __webpack_require__(8);
	var Base64 = __webpack_require__(9);
	var uuid = __webpack_require__(11);
	/**
	 * @export
	 * @class Signer
	 */
	var Signer = /** @class */ (function () {
	    /**
	     * Creates an instance of Signer.
	     * @param {string} apiKey
	     * @param {string} privateKey
	     *
	     * @memberOf Signer
	     */
	    function Signer(apiKey, privateKey) {
	        this._apiKey = apiKey;
	        this._privateKey = privateKey;
	    }
	    /**
	     * @returns {string}
	     *
	     * @memberOf Signer
	     */
	    Signer.prototype.generateNonce = function () {
	        return uuid.v4();
	    };
	    /**
	     * @param {string} url
	     * @param {string} data
	     * @param {string} nonce
	     * @returns {string}
	     *
	     * @memberOf Signer
	     */
	    Signer.prototype.generateSignatureForRequest = function (url, data, nonce) {
	        var uri = this.stripServer(url);
	        var dataPart = data ? data : "";
	        var message = this._apiKey + nonce + uri + dataPart;
	        var decodedKey = Base64.parse(this._privateKey);
	        var signature = crypto_js_1.HmacSHA1(message, decodedKey);
	        signature = signature.toString(Base64);
	        return signature;
	    };
	    /**
	     * @param {string} url
	     * @param {string} data
	     * @param {object} headers
	     *
	     * @memberOf Signer
	     */
	    Signer.prototype.signRequest = function (url, data, headers) {
	        var nonce = this.generateNonce();
	        var signature = this.generateSignatureForRequest(url, data, nonce);
	        //Add nonce and signature to headers
	        headers["nonce"] = nonce;
	        headers["signature"] = signature;
	    };
	    /**
	     * @param {any} url
	     * @returns {string}
	     *
	     * @memberOf Signer
	     */
	    Signer.prototype.stripServer = function (url) {
	        var i, j;
	        if ((i = url.indexOf('://')) > 0 && (j = url.substr(i + 3).indexOf('/')) > 0 && (j += i + 3) + 1 < url.length) {
	            return url.substr(j);
	        }
	        else {
	            return url;
	        }
	    };
	    return Signer;
	}());
	exports.Signer = Signer;


/***/ }),
/* 8 */
/***/ (function(module, exports) {

	module.exports = require("crypto-js");

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(10));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function () {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var C_enc = C.enc;
	
		    /**
		     * Base64 encoding strategy.
		     */
		    var Base64 = C_enc.Base64 = {
		        /**
		         * Converts a word array to a Base64 string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The Base64 string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
		            var map = this._map;
	
		            // Clamp excess bits
		            wordArray.clamp();
	
		            // Convert
		            var base64Chars = [];
		            for (var i = 0; i < sigBytes; i += 3) {
		                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
		                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
		                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;
	
		                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;
	
		                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
		                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
		                }
		            }
	
		            // Add padding
		            var paddingChar = map.charAt(64);
		            if (paddingChar) {
		                while (base64Chars.length % 4) {
		                    base64Chars.push(paddingChar);
		                }
		            }
	
		            return base64Chars.join('');
		        },
	
		        /**
		         * Converts a Base64 string to a word array.
		         *
		         * @param {string} base64Str The Base64 string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
		         */
		        parse: function (base64Str) {
		            // Shortcuts
		            var base64StrLength = base64Str.length;
		            var map = this._map;
		            var reverseMap = this._reverseMap;
	
		            if (!reverseMap) {
		                    reverseMap = this._reverseMap = [];
		                    for (var j = 0; j < map.length; j++) {
		                        reverseMap[map.charCodeAt(j)] = j;
		                    }
		            }
	
		            // Ignore padding
		            var paddingChar = map.charAt(64);
		            if (paddingChar) {
		                var paddingIndex = base64Str.indexOf(paddingChar);
		                if (paddingIndex !== -1) {
		                    base64StrLength = paddingIndex;
		                }
		            }
	
		            // Convert
		            return parseLoop(base64Str, base64StrLength, reverseMap);
	
		        },
	
		        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
		    };
	
		    function parseLoop(base64Str, base64StrLength, reverseMap) {
		      var words = [];
		      var nBytes = 0;
		      for (var i = 0; i < base64StrLength; i++) {
		          if (i % 4) {
		              var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
		              var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
		              words[nBytes >>> 2] |= (bits1 | bits2) << (24 - (nBytes % 4) * 8);
		              nBytes++;
		          }
		      }
		      return WordArray.create(words, nBytes);
		    }
		}());
	
	
		return CryptoJS.enc.Base64;
	
	}));

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory();
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define([], factory);
		}
		else {
			// Global (browser)
			root.CryptoJS = factory();
		}
	}(this, function () {
	
		/**
		 * CryptoJS core components.
		 */
		var CryptoJS = CryptoJS || (function (Math, undefined) {
		    /*
		     * Local polyfil of Object.create
		     */
		    var create = Object.create || (function () {
		        function F() {};
	
		        return function (obj) {
		            var subtype;
	
		            F.prototype = obj;
	
		            subtype = new F();
	
		            F.prototype = null;
	
		            return subtype;
		        };
		    }())
	
		    /**
		     * CryptoJS namespace.
		     */
		    var C = {};
	
		    /**
		     * Library namespace.
		     */
		    var C_lib = C.lib = {};
	
		    /**
		     * Base object for prototypal inheritance.
		     */
		    var Base = C_lib.Base = (function () {
	
	
		        return {
		            /**
		             * Creates a new object that inherits from this object.
		             *
		             * @param {Object} overrides Properties to copy into the new object.
		             *
		             * @return {Object} The new object.
		             *
		             * @static
		             *
		             * @example
		             *
		             *     var MyType = CryptoJS.lib.Base.extend({
		             *         field: 'value',
		             *
		             *         method: function () {
		             *         }
		             *     });
		             */
		            extend: function (overrides) {
		                // Spawn
		                var subtype = create(this);
	
		                // Augment
		                if (overrides) {
		                    subtype.mixIn(overrides);
		                }
	
		                // Create default initializer
		                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
		                    subtype.init = function () {
		                        subtype.$super.init.apply(this, arguments);
		                    };
		                }
	
		                // Initializer's prototype is the subtype object
		                subtype.init.prototype = subtype;
	
		                // Reference supertype
		                subtype.$super = this;
	
		                return subtype;
		            },
	
		            /**
		             * Extends this object and runs the init method.
		             * Arguments to create() will be passed to init().
		             *
		             * @return {Object} The new object.
		             *
		             * @static
		             *
		             * @example
		             *
		             *     var instance = MyType.create();
		             */
		            create: function () {
		                var instance = this.extend();
		                instance.init.apply(instance, arguments);
	
		                return instance;
		            },
	
		            /**
		             * Initializes a newly created object.
		             * Override this method to add some logic when your objects are created.
		             *
		             * @example
		             *
		             *     var MyType = CryptoJS.lib.Base.extend({
		             *         init: function () {
		             *             // ...
		             *         }
		             *     });
		             */
		            init: function () {
		            },
	
		            /**
		             * Copies properties into this object.
		             *
		             * @param {Object} properties The properties to mix in.
		             *
		             * @example
		             *
		             *     MyType.mixIn({
		             *         field: 'value'
		             *     });
		             */
		            mixIn: function (properties) {
		                for (var propertyName in properties) {
		                    if (properties.hasOwnProperty(propertyName)) {
		                        this[propertyName] = properties[propertyName];
		                    }
		                }
	
		                // IE won't copy toString using the loop above
		                if (properties.hasOwnProperty('toString')) {
		                    this.toString = properties.toString;
		                }
		            },
	
		            /**
		             * Creates a copy of this object.
		             *
		             * @return {Object} The clone.
		             *
		             * @example
		             *
		             *     var clone = instance.clone();
		             */
		            clone: function () {
		                return this.init.prototype.extend(this);
		            }
		        };
		    }());
	
		    /**
		     * An array of 32-bit words.
		     *
		     * @property {Array} words The array of 32-bit words.
		     * @property {number} sigBytes The number of significant bytes in this word array.
		     */
		    var WordArray = C_lib.WordArray = Base.extend({
		        /**
		         * Initializes a newly created word array.
		         *
		         * @param {Array} words (Optional) An array of 32-bit words.
		         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.lib.WordArray.create();
		         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
		         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
		         */
		        init: function (words, sigBytes) {
		            words = this.words = words || [];
	
		            if (sigBytes != undefined) {
		                this.sigBytes = sigBytes;
		            } else {
		                this.sigBytes = words.length * 4;
		            }
		        },
	
		        /**
		         * Converts this word array to a string.
		         *
		         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
		         *
		         * @return {string} The stringified word array.
		         *
		         * @example
		         *
		         *     var string = wordArray + '';
		         *     var string = wordArray.toString();
		         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
		         */
		        toString: function (encoder) {
		            return (encoder || Hex).stringify(this);
		        },
	
		        /**
		         * Concatenates a word array to this word array.
		         *
		         * @param {WordArray} wordArray The word array to append.
		         *
		         * @return {WordArray} This word array.
		         *
		         * @example
		         *
		         *     wordArray1.concat(wordArray2);
		         */
		        concat: function (wordArray) {
		            // Shortcuts
		            var thisWords = this.words;
		            var thatWords = wordArray.words;
		            var thisSigBytes = this.sigBytes;
		            var thatSigBytes = wordArray.sigBytes;
	
		            // Clamp excess bits
		            this.clamp();
	
		            // Concat
		            if (thisSigBytes % 4) {
		                // Copy one byte at a time
		                for (var i = 0; i < thatSigBytes; i++) {
		                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
		                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
		                }
		            } else {
		                // Copy one word at a time
		                for (var i = 0; i < thatSigBytes; i += 4) {
		                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
		                }
		            }
		            this.sigBytes += thatSigBytes;
	
		            // Chainable
		            return this;
		        },
	
		        /**
		         * Removes insignificant bits.
		         *
		         * @example
		         *
		         *     wordArray.clamp();
		         */
		        clamp: function () {
		            // Shortcuts
		            var words = this.words;
		            var sigBytes = this.sigBytes;
	
		            // Clamp
		            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
		            words.length = Math.ceil(sigBytes / 4);
		        },
	
		        /**
		         * Creates a copy of this word array.
		         *
		         * @return {WordArray} The clone.
		         *
		         * @example
		         *
		         *     var clone = wordArray.clone();
		         */
		        clone: function () {
		            var clone = Base.clone.call(this);
		            clone.words = this.words.slice(0);
	
		            return clone;
		        },
	
		        /**
		         * Creates a word array filled with random bytes.
		         *
		         * @param {number} nBytes The number of random bytes to generate.
		         *
		         * @return {WordArray} The random word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.lib.WordArray.random(16);
		         */
		        random: function (nBytes) {
		            var words = [];
	
		            var r = (function (m_w) {
		                var m_w = m_w;
		                var m_z = 0x3ade68b1;
		                var mask = 0xffffffff;
	
		                return function () {
		                    m_z = (0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10)) & mask;
		                    m_w = (0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10)) & mask;
		                    var result = ((m_z << 0x10) + m_w) & mask;
		                    result /= 0x100000000;
		                    result += 0.5;
		                    return result * (Math.random() > .5 ? 1 : -1);
		                }
		            });
	
		            for (var i = 0, rcache; i < nBytes; i += 4) {
		                var _r = r((rcache || Math.random()) * 0x100000000);
	
		                rcache = _r() * 0x3ade67b7;
		                words.push((_r() * 0x100000000) | 0);
		            }
	
		            return new WordArray.init(words, nBytes);
		        }
		    });
	
		    /**
		     * Encoder namespace.
		     */
		    var C_enc = C.enc = {};
	
		    /**
		     * Hex encoding strategy.
		     */
		    var Hex = C_enc.Hex = {
		        /**
		         * Converts a word array to a hex string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The hex string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
	
		            // Convert
		            var hexChars = [];
		            for (var i = 0; i < sigBytes; i++) {
		                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
		                hexChars.push((bite >>> 4).toString(16));
		                hexChars.push((bite & 0x0f).toString(16));
		            }
	
		            return hexChars.join('');
		        },
	
		        /**
		         * Converts a hex string to a word array.
		         *
		         * @param {string} hexStr The hex string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
		         */
		        parse: function (hexStr) {
		            // Shortcut
		            var hexStrLength = hexStr.length;
	
		            // Convert
		            var words = [];
		            for (var i = 0; i < hexStrLength; i += 2) {
		                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
		            }
	
		            return new WordArray.init(words, hexStrLength / 2);
		        }
		    };
	
		    /**
		     * Latin1 encoding strategy.
		     */
		    var Latin1 = C_enc.Latin1 = {
		        /**
		         * Converts a word array to a Latin1 string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The Latin1 string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
	
		            // Convert
		            var latin1Chars = [];
		            for (var i = 0; i < sigBytes; i++) {
		                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
		                latin1Chars.push(String.fromCharCode(bite));
		            }
	
		            return latin1Chars.join('');
		        },
	
		        /**
		         * Converts a Latin1 string to a word array.
		         *
		         * @param {string} latin1Str The Latin1 string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
		         */
		        parse: function (latin1Str) {
		            // Shortcut
		            var latin1StrLength = latin1Str.length;
	
		            // Convert
		            var words = [];
		            for (var i = 0; i < latin1StrLength; i++) {
		                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
		            }
	
		            return new WordArray.init(words, latin1StrLength);
		        }
		    };
	
		    /**
		     * UTF-8 encoding strategy.
		     */
		    var Utf8 = C_enc.Utf8 = {
		        /**
		         * Converts a word array to a UTF-8 string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The UTF-8 string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            try {
		                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
		            } catch (e) {
		                throw new Error('Malformed UTF-8 data');
		            }
		        },
	
		        /**
		         * Converts a UTF-8 string to a word array.
		         *
		         * @param {string} utf8Str The UTF-8 string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
		         */
		        parse: function (utf8Str) {
		            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
		        }
		    };
	
		    /**
		     * Abstract buffered block algorithm template.
		     *
		     * The property blockSize must be implemented in a concrete subtype.
		     *
		     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
		     */
		    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
		        /**
		         * Resets this block algorithm's data buffer to its initial state.
		         *
		         * @example
		         *
		         *     bufferedBlockAlgorithm.reset();
		         */
		        reset: function () {
		            // Initial values
		            this._data = new WordArray.init();
		            this._nDataBytes = 0;
		        },
	
		        /**
		         * Adds new data to this block algorithm's buffer.
		         *
		         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
		         *
		         * @example
		         *
		         *     bufferedBlockAlgorithm._append('data');
		         *     bufferedBlockAlgorithm._append(wordArray);
		         */
		        _append: function (data) {
		            // Convert string to WordArray, else assume WordArray already
		            if (typeof data == 'string') {
		                data = Utf8.parse(data);
		            }
	
		            // Append
		            this._data.concat(data);
		            this._nDataBytes += data.sigBytes;
		        },
	
		        /**
		         * Processes available data blocks.
		         *
		         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
		         *
		         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
		         *
		         * @return {WordArray} The processed data.
		         *
		         * @example
		         *
		         *     var processedData = bufferedBlockAlgorithm._process();
		         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
		         */
		        _process: function (doFlush) {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
		            var dataSigBytes = data.sigBytes;
		            var blockSize = this.blockSize;
		            var blockSizeBytes = blockSize * 4;
	
		            // Count blocks ready
		            var nBlocksReady = dataSigBytes / blockSizeBytes;
		            if (doFlush) {
		                // Round up to include partial blocks
		                nBlocksReady = Math.ceil(nBlocksReady);
		            } else {
		                // Round down to include only full blocks,
		                // less the number of blocks that must remain in the buffer
		                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
		            }
	
		            // Count words ready
		            var nWordsReady = nBlocksReady * blockSize;
	
		            // Count bytes ready
		            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);
	
		            // Process blocks
		            if (nWordsReady) {
		                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
		                    // Perform concrete-algorithm logic
		                    this._doProcessBlock(dataWords, offset);
		                }
	
		                // Remove processed words
		                var processedWords = dataWords.splice(0, nWordsReady);
		                data.sigBytes -= nBytesReady;
		            }
	
		            // Return processed words
		            return new WordArray.init(processedWords, nBytesReady);
		        },
	
		        /**
		         * Creates a copy of this object.
		         *
		         * @return {Object} The clone.
		         *
		         * @example
		         *
		         *     var clone = bufferedBlockAlgorithm.clone();
		         */
		        clone: function () {
		            var clone = Base.clone.call(this);
		            clone._data = this._data.clone();
	
		            return clone;
		        },
	
		        _minBufferSize: 0
		    });
	
		    /**
		     * Abstract hasher template.
		     *
		     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
		     */
		    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
		        /**
		         * Configuration options.
		         */
		        cfg: Base.extend(),
	
		        /**
		         * Initializes a newly created hasher.
		         *
		         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
		         *
		         * @example
		         *
		         *     var hasher = CryptoJS.algo.SHA256.create();
		         */
		        init: function (cfg) {
		            // Apply config defaults
		            this.cfg = this.cfg.extend(cfg);
	
		            // Set initial values
		            this.reset();
		        },
	
		        /**
		         * Resets this hasher to its initial state.
		         *
		         * @example
		         *
		         *     hasher.reset();
		         */
		        reset: function () {
		            // Reset data buffer
		            BufferedBlockAlgorithm.reset.call(this);
	
		            // Perform concrete-hasher logic
		            this._doReset();
		        },
	
		        /**
		         * Updates this hasher with a message.
		         *
		         * @param {WordArray|string} messageUpdate The message to append.
		         *
		         * @return {Hasher} This hasher.
		         *
		         * @example
		         *
		         *     hasher.update('message');
		         *     hasher.update(wordArray);
		         */
		        update: function (messageUpdate) {
		            // Append
		            this._append(messageUpdate);
	
		            // Update the hash
		            this._process();
	
		            // Chainable
		            return this;
		        },
	
		        /**
		         * Finalizes the hash computation.
		         * Note that the finalize operation is effectively a destructive, read-once operation.
		         *
		         * @param {WordArray|string} messageUpdate (Optional) A final message update.
		         *
		         * @return {WordArray} The hash.
		         *
		         * @example
		         *
		         *     var hash = hasher.finalize();
		         *     var hash = hasher.finalize('message');
		         *     var hash = hasher.finalize(wordArray);
		         */
		        finalize: function (messageUpdate) {
		            // Final message update
		            if (messageUpdate) {
		                this._append(messageUpdate);
		            }
	
		            // Perform concrete-hasher logic
		            var hash = this._doFinalize();
	
		            return hash;
		        },
	
		        blockSize: 512/32,
	
		        /**
		         * Creates a shortcut function to a hasher's object interface.
		         *
		         * @param {Hasher} hasher The hasher to create a helper for.
		         *
		         * @return {Function} The shortcut function.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
		         */
		        _createHelper: function (hasher) {
		            return function (message, cfg) {
		                return new hasher.init(cfg).finalize(message);
		            };
		        },
	
		        /**
		         * Creates a shortcut function to the HMAC's object interface.
		         *
		         * @param {Hasher} hasher The hasher to use in this HMAC helper.
		         *
		         * @return {Function} The shortcut function.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
		         */
		        _createHmacHelper: function (hasher) {
		            return function (message, key) {
		                return new C_algo.HMAC.init(hasher, key).finalize(message);
		            };
		        }
		    });
	
		    /**
		     * Algorithm namespace.
		     */
		    var C_algo = C.algo = {};
	
		    return C;
		}(Math));
	
	
		return CryptoJS;
	
	}));

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	module.exports = require("uuid");

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @export
	 * @class OauthProvider
	 * @implements {OathInterface}
	 */
	var OauthProvider = /** @class */ (function () {
	    /**
	     * Creates an instance of OauthProvider.
	     * @param {AccessTokenProvider} accessTokenProvider
	     * @param {WebApiConfiguration} config
	     *
	     * @memberOf OauthProvider
	     */
	    function OauthProvider(accessTokenProvider, config) {
	        this.accessTokenProvider = accessTokenProvider;
	        this.config = config;
	    }
	    /**
	     * Returns url for authentication based on provided config
	     * @returns {string}
	     *
	     * @memberOf OauthProvider
	     */
	    OauthProvider.prototype.getOauth2Url = function () {
	        if (this.config.oauth2.clientSecret) {
	            return this.config.environment.oAuth2ContextBaseUrl + "/auth?response_type=code&client_id=" + this.config.oauth2.clientId + "&access_type=offline&redirect_uri=" + this.config.oauth2.redirectUri;
	        }
	        return this.config.environment.oAuth2ContextBaseUrl + "/auth?response_type=token&client_id=" + this.config.oauth2.clientId + "&redirect_uri=" + this.config.oauth2.redirectUri;
	    };
	    /**
	     * Parses callback uri and extracts information that is used for requesting access token
	     *
	     * @param {string} url
	     * @returns {Promise<AccessToken>}
	     *
	     * @memberOf OauthProvider
	     */
	    OauthProvider.prototype.processRedirect = function (url) {
	        if (this.config.oauth2.clientSecret) {
	            try {
	                var code = /code=([^&]*)/.exec(url)[1];
	            }
	            catch (e) {
	                throw new Error('Passed url does not contain code.');
	            }
	            this.accessTokenProvider.useCode(code);
	            return this.accessTokenProvider.getAccessToken();
	        }
	        try {
	            var expiration = /expires_in=([^&]*)/.exec(url)[1];
	            var accessToken = {
	                token: /access_token=([^&]*)/.exec(url)[1],
	                tokenType: /token_type=([^&]*)/.exec(url)[1],
	                expiresIn: Date.now() + (expiration * 1000) - 5000,
	            };
	        }
	        catch (e) {
	            throw new Error('Passed url does not contain access token, token type or expiration.');
	        }
	        this.accessTokenProvider.useAccessToken(accessToken);
	        return this.accessTokenProvider.getAccessToken();
	    };
	    return OauthProvider;
	}());
	exports.OauthProvider = OauthProvider;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/// <reference types="es6-promise" />
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var error_1 = __webpack_require__(2);
	var web_api_client_1 = __webpack_require__(14);
	/**
	 * @export
	 * @class AccessTokenProvider
	 * @implements {AccessTokenProviderInterface}
	 */
	var AccessTokenProvider = /** @class */ (function () {
	    /**
	     * Set access token given in initialization
	     * @param {WebApiConfiguration} config
	     */
	    function AccessTokenProvider(config) {
	        this.client = new AccessTokenProviderClient(config);
	        if (config.oauth2 && config.oauth2.clientSecret) {
	            this.secret = config.oauth2.clientSecret;
	        }
	    }
	    /**
	     * Set token and expiration properties of a given tokeng
	     * @param {AccessToken|string} token
	     * @returns {void}
	     */
	    AccessTokenProvider.prototype.useAccessToken = function (token) {
	        if (typeof token === 'string') {
	            this.token = {
	                token: token,
	                tokenType: 'bearer',
	                expiresIn: Date.now()
	            };
	            return;
	        }
	        this.token = token;
	        this.token.expiresIn = Date.now() + (token.expiresIn * 1000) - 5000;
	    };
	    /**
	     * @param {string} code
	     */
	    AccessTokenProvider.prototype.useCode = function (code) {
	        this.code = code;
	    };
	    /**
	     * @returns {string}
	     */
	    AccessTokenProvider.prototype.getCode = function () {
	        return this.code;
	    };
	    /**
	     * @returns {Promise<AccessToken>}
	     */
	    AccessTokenProvider.prototype.getAccessToken = function () {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            // Resolve with saved access token if it's not expired else call refreshAccessToken method
	            if (_this.token && (Date.now() < _this.token.expiresIn) || !_this.secret) {
	                resolve(_this.token);
	            }
	            else if (_this.token) {
	                _this.refreshAccessToken();
	            }
	            else {
	                if (!_this.code) {
	                    throw new error_1.ConfigurationError('Code has to be set before getting access token. Use ProcessRedirect function for parsing redirect url with code or useCode function to set the code');
	                }
	                var data = {
	                    grant_type: 'authorization_code',
	                    code: _this.code,
	                    client_id: _this.client.config.oauth2.clientId,
	                    client_secret: _this.client.config.oauth2.clientSecret,
	                    redirect_uri: _this.client.config.oauth2.redirectUri,
	                    expires_in: '3600',
	                };
	                _this.client.callApi(_this.client.config.environment.oAuth2ContextBaseUrl + "/token", 'POST', null, _this.joinAndEncodeData(data), { 'Content-Type': 'application/x-www-form-urlencoded', 'web-api-key': '', })
	                    .then(function (token) {
	                    _this.useAccessToken({
	                        token: token.access_token,
	                        tokenType: token.token_type,
	                        expiresIn: token.expires_in
	                    });
	                    resolve(_this.token);
	                });
	            }
	        });
	    };
	    /**
	     * Refresh access token and return it in promise
	     * @returns {Promise<AccessToken>}
	     */
	    AccessTokenProvider.prototype.refreshAccessToken = function () {
	        var _this = this;
	        if (!this.secret) {
	            throw new error_1.ConfigurationError('Access token cannot be refreshed if you use implicit flow');
	        }
	        // Throw ConfigurationError if client is not set
	        if (!this.client) {
	            throw new error_1.ConfigurationError('WebApiClient has to be set on AccessTokenProvider if you want use it');
	        }
	        if (!this.client.config.oauth2.clientId || !this.client.config.oauth2.redirectUri) {
	            throw new error_1.ConfigurationError('clientId and redirectUri has to be set if you want to get access token');
	        }
	        return new Promise(function (resolve, reject) {
	            var data = {
	                refresh_token: _this.token.refreshToken,
	                code: _this.code,
	                client_id: _this.client.config.oauth2.clientId,
	                client_secret: _this.client.config.oauth2.clientSecret,
	                redirect_uri: _this.client.config.oauth2.redirectUri,
	                grant_type: 'refresh_token'
	            };
	            // Call client's makeCall method to perform call on the API server
	            _this.client.callApi(_this.client.config.environment.oAuth2ContextBaseUrl + "/token", 'POST', null, _this.joinAndEncodeData(data), { "Content-Type": "application/x-www-form-urlencoded" }).then(function (token) {
	                // If call is successful then set token and resolve
	                _this.useAccessToken({
	                    token: token.access_token,
	                    tokenType: token.token_type,
	                    expiresIn: token.expires_in
	                });
	                resolve(_this.token);
	            })
	                .catch(function (error) {
	                // reject with error if call is unsuccessful
	                reject(error);
	            });
	        });
	    };
	    /**
	     * Helper method to join and encode data
	     * @private
	     * @param {any} data
	     * @returns {string}
	     */
	    AccessTokenProvider.prototype.joinAndEncodeData = function (data) {
	        var arr = [];
	        for (var prop in data) {
	            arr.push(prop + "=" + data[prop]);
	        }
	        return encodeURI(arr.join('&'));
	    };
	    return AccessTokenProvider;
	}());
	exports.AccessTokenProvider = AccessTokenProvider;
	/**
	 * @export
	 * @class AccessTokenProviderClient
	 * @extends {WebApiClient}
	 */
	var AccessTokenProviderClient = /** @class */ (function (_super) {
	    __extends(AccessTokenProviderClient, _super);
	    function AccessTokenProviderClient(config) {
	        return _super.call(this, config, '') || this;
	    }
	    return AccessTokenProviderClient;
	}(web_api_client_1.WebApiClient));
	exports.AccessTokenProviderClient = AccessTokenProviderClient;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var axios = __webpack_require__(15);
	var error_1 = __webpack_require__(2);
	var signer_1 = __webpack_require__(7);
	/**
	 * @param {any=} response
	 * @returns {string}
	 */
	function extractErrorMessageFromResponse(response) {
	    var errorMessage = "Error during api call";
	    if (!response.data) {
	        return errorMessage;
	    }
	    if (!response.data.errors || typeof (response.data.errors) != "object") {
	        return errorMessage;
	    }
	    if (response.data.errors.length < 1 || !response.data.errors[0].error) {
	        return errorMessage;
	    }
	    return errorMessage + ' - ' + response.data.errors[0].error;
	}
	/**
	 * @export
	 * @abstract
	 * @class WebApiClient
	 * @implements {PathSegment}
	 */
	var WebApiClient = /** @class */ (function () {
	    /**
	     * Creates an instance of WebApiClient.
	     * @param {WebApiConfiguration} config
	     * @param {string} basePath
	     *
	     * @memberOf WebApiClient
	     */
	    function WebApiClient(config, basePath) {
	        //Obtain a copy of config so that we can do modifications to it.
	        this.apiBasePath = basePath;
	        this.config = config;
	        this._ensureRightConfiguration = function () {
	            if (typeof this.config.webApiKey != 'string' || this.config.webApiKey.length == 0) {
	                throw new error_1.ConfigurationError("You have to provide WEB-API-KEY to the SDK before calling the API!");
	            }
	            if (typeof this.config.language != 'string' || this.config.language.length == 0) {
	                //FIXME: Better error message when the packaging becomes more stable
	                throw new error_1.ConfigurationError("You have to provide language in which to communicate with the API!");
	            }
	        };
	    }
	    /**
	     * Returns Base URL for all resources in this client.
	     * @returns {string}
	     *
	     * @memberOf WebApiClient
	     */
	    WebApiClient.prototype.getPath = function () {
	        return this.config.environment.apiContextBaseUrl + this.apiBasePath;
	    };
	    /**
	     * Prepares request for API call
	     * @param {string} url
	     * @param {string} method
	     * @param {any=} params
	     * @param {any=} data
	     * @param {any=} headers
	     * @param {string} [responseType]
	     * @returns {Promise<any>}
	     *
	     * @memberOf WebApiClient
	     */
	    WebApiClient.prototype.callApi = function (url, method, params, data, headers, responseType) {
	        var _this = this;
	        this._ensureRightConfiguration();
	        headers = headers || {};
	        // If client has accessTokenProvider try to get access token and then call makeCall method otherwise only call makeCall method
	        if (this.sharedContext) {
	            var accessTokenErrors_1 = [
	                '"error":"invalid_token"',
	                '"error":"invalid_request"',
	            ];
	            return this.sharedContext
	                .getAccessToken()
	                .then(function (token) {
	                // add access token to headers
	                var tokenHeader = token.tokenType + " " + token.token;
	                headers['Authorization'] = tokenHeader;
	                // call makeCall method with access token in headers and return the result
	                return _this.makeCall(url, method, params, data, headers);
	            })
	                .catch(function (e) {
	                // if access token is invalid try to refresh access token
	                if (e.statusCode === 403 &&
	                    e.response.data.errors &&
	                    e.response.data.errors[0] &&
	                    (e.response.data.errors[0].error.indexOf(accessTokenErrors_1[0]) !== -1 ||
	                        e.response.data.errors[0].error.indexOf(accessTokenErrors_1[1]) !== -1) &&
	                    _this.sharedContext.accessTokenProvider) {
	                    return _this.sharedContext.refreshAccessToken()
	                        .then(function (token) {
	                        // add access token to headers
	                        headers['Authorization'] = token.tokenType + " " + token.token;
	                        // call makeCall method with access token in headers and return the result
	                        return _this.makeCall(url, method, params, data, headers);
	                    })
	                        .catch(function (e) {
	                        // If access token cannot be refreshed or there was any other error then just throw the error
	                        throw e;
	                    });
	                }
	                throw e;
	            });
	        }
	        else {
	            // call makeCall method and return the result
	            return this.makeCall(url, method, params, data, headers, responseType);
	        }
	    };
	    /**
	     * @private
	     * @param {string} url
	     * @param {string} method
	     * @param {any=} params
	     * @param {any=} data
	     * @param {any=} headers
	     * @param {string=} responseType
	     * @returns {any}
	     *
	     * @memberOf WebApiClient
	     */
	    WebApiClient.prototype.makeCall = function (url, method, params, data, headers, responseType) {
	        this._ensureRightConfiguration();
	        var signer = null;
	        var requestTransforms = axios.defaults.transformRequest.slice();
	        if (this.config.signingKey) {
	            signer = new signer_1.Signer(this.config.webApiKey, this.config.signingKey);
	            requestTransforms.push(function (request, headers) {
	                if (signer) {
	                    signer.signRequest(url, data, headers);
	                }
	                return request;
	            });
	        }
	        var reqHeaders = {
	            'web-api-key': this.config.webApiKey,
	            'Accept-Language': this.config.language,
	            "Content-Type": "application/json",
	            "accept": "application/json"
	        };
	        //Add global headers
	        if (WebApiClient.GlobalRequestHeaders) {
	            for (var key in WebApiClient.GlobalRequestHeaders) {
	                reqHeaders[key] = WebApiClient.GlobalRequestHeaders[key];
	            }
	        }
	        //Add custom headers
	        if (headers) {
	            for (var key in headers) {
	                if (headers.hasOwnProperty(key)) {
	                    reqHeaders[key] = headers[key];
	                }
	            }
	        }
	        var config = {
	            url: url,
	            method: method,
	            params: params,
	            data: data,
	            headers: reqHeaders,
	            transformRequest: requestTransforms,
	            responseType: responseType ? responseType : 'json'
	        };
	        var promise = axios(config);
	        return promise
	            .then(function (response) {
	            //TODO: Check status codes, emit relevant errors
	            return response.data;
	        })
	            .catch(function (err) {
	            if (err.data && (Object.prototype.toString.call(err.data) === '[object Uint8Array]')
	                || Object.prototype.toString.call(err.data) === '[object ArrayBuffer]') {
	                err.data = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(err.data)));
	            }
	            throw new error_1.WebApiError(extractErrorMessageFromResponse(err), { "response": err, "statusCode": err.status, "statusText": err.statusText });
	        });
	    };
	    //Hash of all global headers that should be sent
	    WebApiClient.GlobalRequestHeaders = {};
	    return WebApiClient;
	}());
	exports.WebApiClient = WebApiClient;


/***/ }),
/* 15 */
/***/ (function(module, exports) {

	module.exports = require("axios");

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(17));
	__export(__webpack_require__(18));
	__export(__webpack_require__(19));
	__export(__webpack_require__(20));
	var web_api_client_1 = __webpack_require__(14);
	exports.WebApiClient = web_api_client_1.WebApiClient;
	var entity_utils_1 = __webpack_require__(21);
	exports.EntityUtils = entity_utils_1.EntityUtils;


/***/ }),
/* 17 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @export
	 * @class ListResponseStructure
	 * @implements {ListResponse<T>}
	 * @template T
	 */
	var ListResponseStructure = /** @class */ (function () {
	    function ListResponseStructure() {
	    }
	    return ListResponseStructure;
	}());
	exports.ListResponseStructure = ListResponseStructure;
	var PaginatedListResponseStructure = /** @class */ (function () {
	    function PaginatedListResponseStructure() {
	    }
	    return PaginatedListResponseStructure;
	}());
	exports.PaginatedListResponseStructure = PaginatedListResponseStructure;
	var Order;
	(function (Order) {
	    Order["ASCENDING"] = "asc";
	    Order["DESCENDING"] = "desc";
	})(Order = exports.Order || (exports.Order = {}));


/***/ }),
/* 18 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * @export
	 * @abstract
	 * @class Resource
	 * @implements {PathSegment}
	 */
	var Resource = /** @class */ (function () {
	    /**
	     * Creates an instance of Resource.
	     * @param {string} basePath
	     * @param {WebApiClient} client
	     *
	     * @memberOf Resource
	     */
	    function Resource(basePath, client) {
	        this._client = client;
	        this._path = basePath;
	    }
	    /**
	     * Returns the associated WebApiClient
	     * @returns {WebApiClient}
	     *
	     * @memberOf Resource
	     */
	    Resource.prototype.getClient = function () {
	        return this._client;
	    };
	    /**
	     * Returns current URL path
	     * @returns {string}
	     *
	     * @memberOf Resource
	     */
	    Resource.prototype.getPath = function () {
	        return this._path;
	    };
	    /**
	     * @protected
	     * @param {string} appendix
	     * @returns {string}
	     *
	     * @memberOf Resource
	     */
	    Resource.prototype.pathAppendedWith = function (appendix) {
	        if (appendix == null) {
	            return this._path;
	        }
	        return this._path + "/" + appendix;
	    };
	    /**
	     * @protected
	     * @param {any=} params
	     * @returns {Promise<any>}
	     *
	     * @memberOf Resource
	     */
	    Resource.prototype._get = function (params) {
	        return this._client.callApi(this.getPath(), "GET", params);
	    };
	    /**
	     * @protected
	     * @param {string} pathSuffix
	     * @param {any=} params
	     * @returns {Promise<any>}
	     *
	     * @memberOf Resource
	     */
	    Resource.prototype._getWithSuffix = function (pathSuffix, params) {
	        return this._client.callApi(this.getPath() + "/" + pathSuffix, "GET", params);
	    };
	    return Resource;
	}());
	exports.Resource = Resource;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var resource_1 = __webpack_require__(18);
	/**
	 * @export
	 * @abstract
	 * @class InstanceResource
	 * @extends {Resource}
	 */
	var InstanceResource = /** @class */ (function (_super) {
	    __extends(InstanceResource, _super);
	    /**
	     * Creates an instance of InstanceResource.
	     * @param {any} id
	     * @param {string} basePath
	     * @param {WebApiClient} client
	     *
	     * @memberOf InstanceResource
	     */
	    function InstanceResource(id, basePath, client) {
	        var _this = _super.call(this, basePath, client) || this;
	        _this._id = id;
	        return _this;
	    }
	    Object.defineProperty(InstanceResource.prototype, "id", {
	        /**
	         * Returns id of the WebApi entity this instance resource represents
	         * @readonly
	         * @type {any}
	         * @memberOf InstanceResource
	         */
	        get: function () {
	            return this._id;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Returns utl path of this instance resource
	     * @returns {string}
	     *
	     * @memberOf InstanceResource
	     */
	    InstanceResource.prototype.getPath = function () {
	        return this._path + "/" + String(this.id);
	    };
	    return InstanceResource;
	}(resource_1.Resource));
	exports.InstanceResource = InstanceResource;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var entity_utils_1 = __webpack_require__(21);
	var error_1 = __webpack_require__(2);
	var lists_1 = __webpack_require__(17);
	/**
	 * @export
	 * @class ResourceUtils
	 */
	var ResourceUtils = /** @class */ (function () {
	    function ResourceUtils() {
	    }
	    /**
	     * @static
	     * @template TResponse
	     * @param {Resource} resource
	     * @param {any} params
	     * @returns {Promise<TResponse>}
	     *
	     * @memberOf ResourceUtils
	     */
	    ResourceUtils.CallGet = function (resource, params) {
	        return ResourceUtils.CallGetWithSuffix(resource, null, params);
	    };
	    /**
	     * @static
	     * @template TResponse
	     * @param {Resource} resource
	     * @param {string} pathSuffix
	     * @param {any} params
	     * @returns {Promise<TResponse>}
	     *
	     * @memberOf ResourceUtils
	     */
	    ResourceUtils.CallGetWithSuffix = function (resource, pathSuffix, params) {
	        return ResourceUtils.CallApiWithSuffix(resource, pathSuffix, "GET", params);
	    };
	    /**
	     * @static
	     * @template TRequest
	     * @template TResponse
	     * @param {Resource} resource
	     * @param {TRequest=} payload
	     * @returns {Promise<TResponse>}
	     *
	     * @memberOf ResourceUtils
	     */
	    ResourceUtils.CallCreate = function (resource, payload) {
	        return ResourceUtils.CallCreateWithSuffix(resource, null, payload);
	    };
	    /**
	     * @static
	     * @template TRequest
	     * @template TResponse
	     * @param {Resource} resource
	     * @param {string} pathSuffix
	     * @param {TRequest=} payload
	     * @returns {Promise<TResponse>}
	     *
	     * @memberOf ResourceUtils
	     */
	    ResourceUtils.CallCreateWithSuffix = function (resource, pathSuffix, payload) {
	        return ResourceUtils.CallApiWithSuffix(resource, pathSuffix, "POST", null, payload, null);
	    };
	    /**
	     * @static
	     * @template TRequest
	     * @template TResponse
	     * @param {Resource} resource
	     * @param {TRequest=} payload
	     * @returns {Promise<TResponse>}
	     *
	     * @memberOf ResourceUtils
	     */
	    ResourceUtils.CallUpdate = function (resource, payload) {
	        return ResourceUtils.CallUpdateWithSuffix(resource, null, payload);
	    };
	    /**
	     * @static
	     * @template TRequest
	     * @template TResponse
	     * @param {Resource} resource
	     * @param {string} pathSuffix
	     * @param {TRequest=} payload
	     * @returns {Promise<TResponse>}
	     *
	     * @memberOf ResourceUtils
	     */
	    ResourceUtils.CallUpdateWithSuffix = function (resource, pathSuffix, payload) {
	        return ResourceUtils.CallApiWithSuffix(resource, pathSuffix, "PUT", null, payload, null);
	    };
	    /**
	     * @static
	     * @template TResponse
	     * @param {Resource} resource
	     * @param {any} params
	     * @returns {Promise<TResponse>}
	     *
	     * @memberOf ResourceUtils
	     */
	    ResourceUtils.CallDelete = function (resource, params) {
	        return ResourceUtils.CallDeleteWithSuffix(resource, null, params);
	    };
	    /**
	     * @static
	     * @template TResponse
	     * @param {Resource} resource
	     * @param {string} pathSuffix
	     * @param {any} params
	     * @returns {Promise<TResponse>}
	     *
	     * @memberOf ResourceUtils
	     */
	    ResourceUtils.CallDeleteWithSuffix = function (resource, pathSuffix, params) {
	        return ResourceUtils.CallApiWithSuffix(resource, pathSuffix, "DELETE", params);
	    };
	    /**
	     * @template TResponse
	     * @param {Resource} resource
	     * @param {string} pathSuffix
	     * @param {string} method
	     * @param {any=} params
	     * @param {Uint8Array} data
	     * @param {any=} headers
	     * @returns {Promise<TResponse>}
	     *
	     * @memberOf ResourceUtils
	     */
	    ResourceUtils.prototype.UploadDataWithSuffix = function (resource, pathSuffix, method, params, data, headers) {
	        return ResourceUtils.CallApiWithSuffix(resource, pathSuffix, method, params, data, headers);
	    };
	    /**
	     * @static
	     * @template TData
	     * @template TResponse
	     * @param {Resource} resource
	     * @param {string} pathSuffix
	     * @param {string} method
	     * @param {any=} params
	     * @param {TData=} data
	     * @param {any=} headers
	     * @returns {Promise<TResponse>}
	     *
	     * @memberOf ResourceUtils
	     */
	    ResourceUtils.CallDownload = function (resource, pathSuffix, method, params, data, headers) {
	        return ResourceUtils.CallApiWithSuffix(resource, pathSuffix, method, params, data, headers, 'arraybuffer');
	    };
	    /**
	     * @static
	     * @template TData
	     * @template TResponse
	     * @param {Resource} resource
	     * @param {string} pathSuffix
	     * @param {string} method
	     * @param {any=} params
	     * @param {TData=} data
	     * @param {any=} headers
	     * @param {string=} responseType
	     * @returns {Promise<TResponse>}
	     *
	     * @memberOf ResourceUtils
	     */
	    ResourceUtils.CallApiWithSuffix = function (resource, pathSuffix, method, params, data, headers, responseType) {
	        var url = pathFromResource(resource, pathSuffix);
	        return resource.getClient().callApi(url, method, params, data, headers, responseType);
	    };
	    /**
	     * @static
	     * @template TItem
	     * @param {Resource} resource
	     * @param {string} pathSuffix
	     * @param {string=} itemsKey
	     * @param {any=} params
	     * @param {function=} responseTransform
	     * @returns {Promise<PaginatedListResponse<TItem>>}
	     *
	     * @memberOf ResourceUtils
	     */
	    ResourceUtils.CallPaginatedListWithSuffix = function (resource, pathSuffix, itemsKey, params, responseTransform) {
	        var parameters = {};
	        if (params) {
	            params = entity_utils_1.EntityUtils.copyData(params);
	            //TODO: Extract to ListParamUtils
	            if (ListRequestUtils.isPaginated(params)) {
	                params["size"] = params.pageSize;
	                params["page"] = params.pageNumber;
	                delete params.pageNumber;
	                delete params.pageSize;
	            }
	            if (ListRequestUtils.isSortable(params)) {
	                if (Array.isArray(params['sort'])) {
	                    params['sort'] = params['sort'].join(',');
	                }
	                if (Array.isArray(params['order'])) {
	                    params['order'] = params['order'].join(',');
	                }
	            }
	            //Copy the rest
	            for (var k in params)
	                parameters[k] = params[k];
	        }
	        var promise = ResourceUtils.CallApiWithSuffix(resource, pathSuffix, "GET", params, null, null).then(function (data) {
	            var listStructure = new lists_1.PaginatedListResponseStructure();
	            if (itemsKey) {
	                listStructure.items = data[itemsKey];
	            }
	            else {
	                listStructure.items = data;
	            }
	            if (!listStructure.items) {
	                listStructure.items = [];
	            }
	            listStructure.pagination = ListRequestUtils.paginationFromListData(data);
	            listStructure.nextPage = function () {
	                var nextPageParams = entity_utils_1.EntityUtils.copyData(parameters);
	                nextPageParams["page"] = listStructure.pagination.nextPage;
	                var promise = ResourceUtils.CallPaginatedListWithSuffix(resource, pathSuffix, itemsKey, nextPageParams, responseTransform);
	                return promise;
	            };
	            listStructure.prevPage = function () {
	                var prevPageParams = entity_utils_1.EntityUtils.copyData(parameters);
	                prevPageParams["page"] = listStructure.pagination.prevPage;
	                if (prevPageParams["page"] === null) {
	                    return Promise.reject(new error_1.WebApiError("You cannot call prevPage on page 0"));
	                }
	                var promise = ResourceUtils.CallPaginatedListWithSuffix(resource, pathSuffix, itemsKey, prevPageParams, responseTransform);
	                return promise;
	            };
	            return responseTransform(listStructure);
	        });
	        return promise;
	    };
	    /**
	     * @static
	     * @template TItem
	     * @param {Resource} resource
	     * @param {string} pathSuffix
	     * @param {string=} itemsKey
	     * @param {any=} params
	     * @returns {Promise<ListResponse<TItem>>}
	     *
	     * @memberOf ResourceUtils
	     */
	    ResourceUtils.CallListWithSuffix = function (resource, pathSuffix, itemsKey, params) {
	        var parameters = {};
	        if (params) {
	            if (ListRequestUtils.isSortable(params)) {
	                if (Array.isArray(params['sort'])) {
	                    params['sort'] = params['sort'].join(',');
	                }
	                if (Array.isArray(params['order'])) {
	                    params['order'] = params['order'].join(',');
	                }
	            }
	            //Copy the rest
	            for (var k in params)
	                parameters[k] = params[k];
	        }
	        var promise = ResourceUtils.CallApiWithSuffix(resource, pathSuffix, "GET", params, null, null).then(function (data) {
	            var listStructure = new lists_1.ListResponseStructure();
	            if (itemsKey) {
	                listStructure.items = data[itemsKey];
	            }
	            else {
	                listStructure.items = data;
	            }
	            if (!listStructure.items) {
	                listStructure.items = [];
	            }
	            return listStructure;
	        });
	        return promise;
	    };
	    return ResourceUtils;
	}());
	exports.ResourceUtils = ResourceUtils;
	function pathFromResource(resource, appendix) {
	    if (appendix == null) {
	        return resource.getPath();
	    }
	    return resource.getPath() + "/" + appendix;
	}
	/**
	 * @class ListRequestUtils
	 */
	var ListRequestUtils = /** @class */ (function () {
	    function ListRequestUtils() {
	    }
	    /**
	     * @static
	     * @param {any} params
	     * @returns {params is Paginated}
	     *
	     * @memberOf ListRequestUtils
	     */
	    ListRequestUtils.isPaginated = function (params) {
	        return params.pageNumber != null && params.pageSize != null;
	    };
	    /**
	     * @static
	     * @param {any} params
	     * @returns {params is Sortable}
	     *
	     * @memberOf ListRequestUtils
	     */
	    ListRequestUtils.isSortable = function (params) {
	        return params.sort != null && params.order != null;
	    };
	    /**
	     * @static
	     * @param {any} data
	     * @returns {Pagination}
	     *
	     * @memberOf ListRequestUtils
	     */
	    ListRequestUtils.paginationFromListData = function (data) {
	        if (data["pageNumber"] !== undefined) {
	            var pagination = new PaginationStructure();
	            pagination.pageNumber = data["pageNumber"];
	            pagination.pageCount = data["pageCount"];
	            pagination.pageSize = data["pageSize"];
	            pagination.nextPage = data["nextPage"];
	            pagination.prevPage = data["pageNumber"] === 0 ? null : data["pageNumber"] - 1;
	            pagination.hasNextPage = typeof (data["nextPage"]) === "number" && pagination.pageNumber !== pagination.nextPage;
	            pagination.hasPrevPage = typeof (data["pageNumber"]) === "number" && pagination.pageNumber !== 0;
	            return pagination;
	        }
	        return null;
	    };
	    return ListRequestUtils;
	}());
	/**
	 * @class PaginationStructure
	 * @implements {Pagination}
	 */
	var PaginationStructure = /** @class */ (function () {
	    function PaginationStructure() {
	    }
	    return PaginationStructure;
	}());


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(22);
	var date_fns_1 = __webpack_require__(23);
	/**
	 * @export
	 * @class EntityUtils
	 */
	var EntityUtils = /** @class */ (function () {
	    function EntityUtils() {
	    }
	    /**
	     * @static
	     * @param {any} obj
	     * @param {any} f
	     * @param {any} [ctx=null]
	     * @returns
	     *
	     * @memberOf EntityUtils
	     */
	    EntityUtils.deepMap = function (obj, f, ctx) {
	        if (ctx === void 0) { ctx = null; }
	        if (Array.isArray(obj)) {
	            return obj.map(function (val, key) {
	                return (typeof val === 'object') ? this.deepMap(val, f, ctx) : f.call(ctx, val, key);
	            });
	        }
	        else if (typeof obj === 'object') {
	            var res = {};
	            for (var key in obj) {
	                var val = obj[key];
	                if (typeof val === 'object') {
	                    res[key] = this.deepMap(val, f, ctx);
	                }
	                else {
	                    res[key] = f.call(ctx, val, key);
	                }
	            }
	            return res;
	        }
	        else {
	            return obj;
	        }
	    };
	    /**
	     * Marks response that is signable. It has SigningObject with key signing available.
	     * @static
	     * @param {any} object
	     * @param {string} idKey
	     *
	     * @memberOf EntityUtils
	     */
	    EntityUtils.addIdProperty = function (object, idKey) {
	        Object.defineProperty(object, "id", {
	            get: function () {
	                if (object[idKey]) {
	                    return object[idKey];
	                }
	                return null;
	            },
	            enumerable: true,
	            configurable: true
	        });
	    };
	    /**
	     * @static
	     * @param {any} object
	     * @returns {*}
	     *
	     * @memberOf EntityUtils
	     */
	    EntityUtils.copyData = function (object) {
	        return JSON.parse(JSON.stringify(object));
	    };
	    /**
	     * @static
	     * @param {any} object
	     * @param {string} oldName
	     * @param {string} newName
	     *
	     * @memberOf EntityUtils
	     */
	    EntityUtils.renameProperty = function (object, oldName, newName) {
	        if (object[oldName]) {
	            object[newName] = object[oldName];
	            delete object[oldName];
	        }
	    };
	    /**
	     * @static
	     * @param {function} accessFunction
	     * @param {any} key
	     * @param {function} transformFunction
	     *
	     * @memberOf EntityUtils
	     */
	    EntityUtils.tryTransform = function (accessFunction, key, transformFunction) {
	        var accessed = null;
	        try {
	            accessed = accessFunction()[key];
	        }
	        catch (e) {
	            //TODO: Make logging conditional
	            console.log('INFO: unable to access property: ' + key);
	            console.log(e);
	        }
	        accessFunction()[key] = transformFunction(accessed);
	    };
	    /**
	     * @static
	     * @param {function} accessFunction
	     * @param {any} key
	     *
	     * @memberOf EntityUtils
	     */
	    EntityUtils.tryStringToDateTransform = function (accessFunction, key) {
	        var _this = this;
	        this.tryTransform(accessFunction, key, function (val) {
	            var timestamp = _this.parseISODate(val);
	            if (typeof (timestamp) == 'number') {
	                return new Date(timestamp);
	            }
	            else {
	                return val;
	            }
	        });
	    };
	    /**
	     * @static
	     * @param {function} accessFunction
	     * @param {any} key
	     *
	     * @memberOf EntityUtils
	     */
	    EntityUtils.tryStringify = function (accessFunction, key) {
	        this.tryTransform(accessFunction, key, function (val) {
	            if (val != null) {
	                return val.toString();
	            }
	            else {
	                return val;
	            }
	        });
	    };
	    /**
	     * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
	     * NON-CONFORMANT EDITION.
	     * © 2011 Colin Snover <http://zetafleet.com>
	     * Released under MIT license.
	     *
	     * @param {any} date
	     * @returns {number}
	     */
	    EntityUtils.parseISODate = function (date) {
	        var origParse = Date.parse, numericKeys = [1, 4, 5, 6, 10, 11];
	        var timestamp, struct, minutesOffset = 0;
	        //              1 YYYY                 2 MM        3 DD              4 HH     5 mm        6 ss            7 msec         8 Z 9 ±    10 tzHH    11 tzmm
	        if ((struct = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/.exec(date))) {
	            // avoid NaN timestamps caused by “undefined” values being passed to Date.UTC
	            for (var i = 0, k; (k = numericKeys[i]); ++i) {
	                struct[k] = +struct[k] || 0;
	            }
	            // allow undefined days and months
	            struct[2] = (+struct[2] || 1) - 1;
	            struct[3] = +struct[3] || 1;
	            // allow arbitrary sub-second precision beyond milliseconds
	            struct[7] = struct[7] ? +(struct[7] + "00").substr(0, 3) : 0;
	            // timestamps without timezone identifiers should be considered local time
	            if ((struct[8] === undefined || struct[8] === '') && (struct[9] === undefined || struct[9] === '')) {
	                timestamp = +new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7]);
	            }
	            else {
	                if (struct[8] !== 'Z' && struct[9] !== undefined) {
	                    minutesOffset = struct[10] * 60 + struct[11];
	                    if (struct[9] === '+') {
	                        minutesOffset = 0 - minutesOffset;
	                    }
	                }
	                timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
	            }
	        }
	        else {
	            timestamp = origParse ? origParse(date) : NaN;
	        }
	        return timestamp;
	    };
	    /**
	     * Copy all of the properties in the source objects over to the destination object,
	     * and return the destination object. It's in-order, so the last source will override
	     * properties of the same name in previous arguments.
	     *
	     * @param {object} originalParams
	     * @param {object} additionalParams
	     * @returns {void}
	     */
	    EntityUtils.extend = function (originalParams, additionalParams) {
	        lodash_1.extend(originalParams, additionalParams);
	    };
	    /**
	     * @static
	     * @param {string|string[]} dates
	     * @param {any} obj
	     * @returns {void}
	     *
	     * @memberOf EntityUtils
	     */
	    EntityUtils.addDatesFromISO = function (dates, obj) {
	        var _this = this;
	        if (!obj) {
	            return;
	        }
	        if (typeof dates === 'string') {
	            this.addISODate(dates, obj);
	            return;
	        }
	        dates.forEach(function (date) {
	            _this.addISODate(date, obj);
	        });
	    };
	    /**
	     * @static
	     * @param {any} dates
	     * @param {any} obj
	     * @param {string} [items] itemsKey
	     * @returns {void}
	     *
	     * @memberOf EntityUtils
	     */
	    EntityUtils.addDatesToItems = function (dates, obj, itemsKey) {
	        var _this = this;
	        if (itemsKey === void 0) { itemsKey = 'items'; }
	        if (!obj[itemsKey]) {
	            return;
	        }
	        obj[itemsKey].forEach(function (item) {
	            _this.addDatesFromISO(dates, item);
	        });
	    };
	    /**
	     * @static
	     * @param {any} dates
	     * @param {object} obj
	     * @returns {void}
	     *
	     * @memberOf EntityUtils
	     */
	    EntityUtils.transformDatesToISO = function (dates, obj) {
	        if (!obj) {
	            return;
	        }
	        if (typeof dates === 'string') {
	            if (obj.hasOwnProperty(dates)) {
	                obj[dates] = date_fns_1.format(obj[dates], 'YYYY-MM-DDTHH:mm:ssZ');
	            }
	            return;
	        }
	        dates.forEach(function (date) {
	            if (obj.hasOwnProperty(date)) {
	                obj[date] = date_fns_1.format(obj[date], 'YYYY-MM-DDTHH:mm:ssZ');
	            }
	        });
	    };
	    /**
	     * @static
	     * @param {any} dates
	     * @param {object} obj
	     * @returns {void}
	     *
	     * @memberOf EntityUtils
	     */
	    EntityUtils.transformDatesToSimpleISO = function (dates, obj) {
	        if (typeof dates === 'string') {
	            if (obj.hasOwnProperty(dates)) {
	                obj[dates] = date_fns_1.format(obj[dates], 'YYYY-MM-DD');
	            }
	            return;
	        }
	        dates.forEach(function (date) {
	            if (obj.hasOwnProperty(date)) {
	                obj[date] = date_fns_1.format(obj[date], 'YYYY-MM-DD');
	            }
	        });
	    };
	    /**
	     * @static
	     * @param {any} params
	     * @param {any} paramKey
	     * @returns {void}
	     *
	     * @memberOf EntityUtils
	     */
	    EntityUtils.transformArrayParamsToString = function (params, paramKey) {
	        var _this = this;
	        if (Array.isArray(paramKey)) {
	            paramKey.forEach(function (key) {
	                _this.transformParamsToString(params, key);
	            });
	            return;
	        }
	        this.transformParamsToString(params, paramKey);
	    };
	    /**
	     * @static
	     * @param {string} path
	     * @param {any} params
	     * @returns {string}
	     *
	     * @memberOf EntityUtils
	     */
	    EntityUtils.addParamsToPath = function (path, params) {
	        if (!params || Object.keys(params).length === 0) {
	            return path;
	        }
	        var queryParams = [];
	        for (var prop in params) {
	            queryParams.push(prop + "=" + params[prop]);
	        }
	        return encodeURI(path + "?" + queryParams.join('&'));
	    };
	    /**
	     * @private
	     * @static
	     * @param {any} params
	     * @param {any} paramKey
	     * @returns {void}
	     *
	     * @memberOf EntityUtils
	     */
	    EntityUtils.transformParamsToString = function (params, paramKey) {
	        if (params && Array.isArray(params[paramKey])) {
	            params[paramKey] = params[paramKey].join(',');
	        }
	    };
	    /**
	     * @private
	     * @static
	     * @param {any} date
	     * @param {any} obj
	     * @returns {void}
	     *
	     * @memberOf EntityUtils
	     */
	    EntityUtils.addISODate = function (date, obj) {
	        if (obj[date] !== undefined && typeof obj[date] === 'string') {
	            obj[date] = new Date(this.parseISODate(obj[date]));
	        }
	    };
	    return EntityUtils;
	}());
	exports.EntityUtils = EntityUtils;


/***/ }),
/* 22 */
/***/ (function(module, exports) {

	module.exports = require("lodash");

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	module.exports = require("date-fns");

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var axios = __webpack_require__(15);
	var environment_1 = __webpack_require__(5);
	var web_api_client_1 = __webpack_require__(14);
	var uuid = __webpack_require__(11);
	/**
	 * @export
	 * @class JudgeSession
	 */
	var JudgeSession = /** @class */ (function () {
	    /**
	     * Creates an instance of JudgeSession.
	     * @param {string} sessionId
	     * @param {string} [baseUrl]
	     *
	     * @memberOf JudgeSession
	     */
	    function JudgeSession(sessionId, baseUrl) {
	        this.sessionId = null;
	        this.sessionId = sessionId;
	        if (baseUrl) {
	            this.baseUrl = baseUrl;
	        }
	        else {
	            this.baseUrl = Judge.DefaultBaseURL;
	        }
	    }
	    /**
	     * @param {string} nextCase
	     * @returns {Promise<any>}
	     *
	     * @memberOf JudgeSession
	     */
	    JudgeSession.prototype.setNextCase = function (nextCase) {
	        var nextCaseEndpointUrl = this.baseUrl + "/judge/nextCase";
	        return axios.post(nextCaseEndpointUrl, null, {
	            headers: {
	                "x-judge-case": nextCase,
	                "x-judge-session": this.sessionId
	            }
	        });
	    };
	    return JudgeSession;
	}());
	exports.JudgeSession = JudgeSession;
	/**
	 * @export
	 * @class Judge
	 */
	var Judge = /** @class */ (function () {
	    /**
	     * Creates an instance of Judge.
	     * @param {string=} baseUrl
	     *
	     * @memberOf Judge
	     */
	    function Judge(baseUrl) {
	        if (baseUrl) {
	            this.baseUrl = baseUrl;
	        }
	        else {
	            this.baseUrl = Judge.DefaultBaseURL;
	        }
	    }
	    Object.defineProperty(Judge.prototype, "testEnvironment", {
	        /**
	         * @readonly
	         * @returns {Environment}
	         *
	         * @memberOf Judge
	         */
	        get: function () {
	            return new environment_1.Environment(this.baseUrl + "/webapi", "");
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * @returns {JudgeSession}
	     *
	     * @memberOf Judge
	     */
	    Judge.prototype.startNewSession = function () {
	        Judge.CurrentSessionId = uuid.v4();
	        web_api_client_1.WebApiClient.GlobalRequestHeaders[Judge.JudgeSessionHeaderName] = Judge.CurrentSessionId;
	        return new JudgeSession(Judge.CurrentSessionId, this.baseUrl);
	    };
	    Judge.JudgeSessionHeaderName = "x-judge-session";
	    Judge.JudgeCaseHeaderName = "x-judge-case";
	    Judge.DefaultBaseURL = "http://csas-judge.herokuapp.com";
	    Judge.DefaultTestEnvironment = new environment_1.Environment(Judge.DefaultBaseURL + "/webapi", "");
	    /**
	     * @private
	     * @static
	     * @type {string}
	     * @memberOf Judge
	     */
	    Judge.CurrentSessionId = null;
	    return Judge;
	}());
	exports.Judge = Judge;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var entity_utils_1 = __webpack_require__(21);
	/**
	 * @export
	 * @class TestUtils
	 */
	var TestUtils = /** @class */ (function () {
	    function TestUtils() {
	    }
	    /**
	     * @static
	     * @param {any} obj
	     * @param {any} props
	     *
	     * @memberOf TestUtils
	     */
	    TestUtils.expectToBe = function (obj, props) {
	        var keys = Object.keys(props);
	        keys.forEach(function (key) {
	            expect(obj[key]).toBe(props[key]);
	        });
	    };
	    /**
	     * @static
	     * @param {any} e
	     *
	     * @memberOf TestUtils
	     */
	    TestUtils.logJudgeError = function (e) {
	        console.log(e);
	        if (e.response && e.response.data) {
	            console.log(e.response.data.errors);
	        }
	        else if (e.data) {
	            console.log(e.data.errors);
	        }
	        console.log(e.stack);
	    };
	    /**
	     * @static
	     * @param {object} target
	     * @param {object} dates
	     *
	     * @memberOf TestUtils
	     */
	    TestUtils.expectDate = function (target, dates) {
	        var keys = Object.keys(dates);
	        keys.forEach(function (key) {
	            expect(target[key].toString()).toBe(new Date(entity_utils_1.EntityUtils.parseISODate(dates[key])).toString());
	        });
	    };
	    /**
	     * @static
	     * @param {string} url
	     * @param {string} toBeUrl
	     * @returns {void}
	     *
	     * @memberOf TestUtils
	     */
	    TestUtils.expectUrl = function (url, toBeUrl) {
	        var regex = /(.+)(\/webapi.+)/;
	        expect(url.replace(regex, '$2')).toBe(toBeUrl);
	    };
	    return TestUtils;
	}());
	exports.TestUtils = TestUtils;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	var filled_signing_object_1 = __webpack_require__(27);
	exports.FilledSigningObject = filled_signing_object_1.FilledSigningObject;
	__export(__webpack_require__(30));
	var request_signer_1 = __webpack_require__(29);
	exports.RequestSigner = request_signer_1.RequestSigner;
	var signing_object_1 = __webpack_require__(28);
	exports.SigningObject = signing_object_1.SigningObject;
	var signing_utils_1 = __webpack_require__(31);
	exports.SigningUtils = signing_utils_1.SigningUtils;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var lodash_1 = __webpack_require__(22);
	var signing_object_1 = __webpack_require__(28);
	/**
	 * @export
	 * @class FilledSigningObject
	 * @extends {SigningObject}
	 */
	var FilledSigningObject = /** @class */ (function (_super) {
	    __extends(FilledSigningObject, _super);
	    /**
	     * Creates an instance of FilledSigningObject.
	     * @param {GetInfoResponse} response
	     * @param {WebApiClient} client
	     * @param {string} url
	     * @param {any} order
	     *
	     * @memberOf FilledSigningObject
	     */
	    function FilledSigningObject(response, client, url, order) {
	        var _this = _super.call(this, response, client, url) || this;
	        /**
	         * Returns itself in Promise.
	         * @returns {Promise<FilledSigningObject>}
	         *
	         * @memberOf FilledSigningObject
	         */
	        _this.getInfo = function () {
	            return Promise.resolve(_this);
	        };
	        /**
	         * Starts signing process with TAC (that usually means signing using OneTimePassword from SMS)
	         * This method will inform the API that the client will sign using TAC.
	         * Returned 'TACSigningProcess' is used to finish the signing or throws Error if the call fails
	         * @returns {Promise<TacSigningProcess>}
	         *
	         * @memberOf FilledSigningObject
	         */
	        _this.startSigningWithTac = function () { return _this.requestSigner.startSigningWithTac(_this.signId).then(function (process) {
	            process.signingObject.order = _this.order;
	            _this.order.signing = process.signingObject;
	            return process;
	        }); };
	        /**
	         * Starts signing process with CASE_MOBILE (that usually means signing using OneTimePassword from SMS)
	         * This method will inform the API that the client will sign using CASE_MOBILE.
	         * Returned 'CaseMobileSigningProcess' is used to finish the signing or throws Error if the call fails
	         * @returns {Promise<CaseMobileSigningProcess>}
	         *
	         * @memberOf FilledSigningObject
	         */
	        _this.startSigningWithCaseMobile = function () { return _this.requestSigner.startSigningWithCaseMobile(_this.signId).then(function (process) {
	            process.signingObject.order = _this.order;
	            _this.order.signing = process.signingObject;
	            return process;
	        }); };
	        /**
	         * Starts signing process with NO_AUTHORIZATION (that usually means signing the order just by clicking some button in UI)
	         * This method signalizes the intent to the API that this order will be signed using NO_AUTHORIZATION method
	         * Returned 'NoAuthSigningProcess' is used to finish the signing or throws Error if the call fails
	         * @returns {Promise<NoAuthSigningProcess>}
	         *
	         * @memberOf FilledSigningObject
	         */
	        _this.startSigningWithNoAuthorization = function () { return _this.requestSigner.startSigningWithNoAuthorization(_this.signId).then(function (process) {
	            process.signingObject.order = _this.order;
	            _this.order.signing = process.signingObject;
	            return process;
	        }); };
	        /**
	         * Determines whether the signing can be currently done with the given AuthorizationType.
	         * @param {string} authorizationType
	         * @returns {boolean}
	         *
	         * @memberOf FilledSigningObject
	         */
	        _this.canBeSignedWith = function (authorizationType) { return lodash_1.includes(lodash_1.flatten(_this.scenarios), authorizationType); };
	        /**
	         * List all current possible authorization types. The list will be empty if the entity is not in a signable state.
	         * @returns {string[]}
	         *
	         * @memberOf FilledSigningObject
	         */
	        _this.getPossibleAuthorizationTypes = function () { return lodash_1.uniq(lodash_1.flatten(_this.scenarios)); };
	        _this.authorizationType = response.authorizationType;
	        _this.scenarios = response.scenarios;
	        _this.order = order;
	        return _this;
	    }
	    return FilledSigningObject;
	}(signing_object_1.SigningObject));
	exports.FilledSigningObject = FilledSigningObject;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var request_signer_1 = __webpack_require__(29);
	/**
	 * @export
	 * @class SigningObject
	 */
	var SigningObject = /** @class */ (function () {
	    /**
	     * Creates an instance of SigningObject.
	     * @param {any} order
	     * @param {WebApiClient} client
	     * @param {string} url
	     *
	     * @memberOf SigningObject
	     */
	    function SigningObject(order, client, url) {
	        var _this = this;
	        /**
	         * Obtains current signing info with full details from the API. This method always fetches fresh `FilledSigningObject` from the API.
	         * @returns {Promise<FilledSigningObject>}
	         *
	         * @memberOf SigningObject
	         */
	        this.refreshSigningInfo = function () { return _this.requestSigner.getSigningInfo(_this.signId, _this.order); };
	        /**
	         * Obtains current signing info with full details from the API OR it returns itself if this signing object is already a `FilledSigningObject`
	         * @returns {Promise<FilledSigningObject>}
	         *
	         *
	         * @memberOf SigningObject
	         */
	        this.getInfo = function () { return _this.requestSigner.getSigningInfo(_this.signId, _this.order); };
	        /**
	         * Returns true or false based on state property
	         * @returns {boolean}
	         *
	         * @memberOf SigningObject
	         */
	        this.isDone = function () { return _this.state === 'DONE'; };
	        /**
	         * Returns true or false based on state property
	         * @returns {boolean}
	         *
	         * @memberOf SigningObject
	         */
	        this.isOpen = function () { return _this.state === 'OPEN'; };
	        /**
	         * Returns true or false based on state property
	         * @returns {boolean}
	         *
	         * @memberOf SigningObject
	         */
	        this.isCanceled = function () { return _this.state === 'CANCELED'; };
	        this.state = order.signInfo.state;
	        this.signId = order.signInfo.signId;
	        this.order = order;
	        // construct new RequestSigner for every order
	        this.requestSigner = new request_signer_1.RequestSigner(client, url);
	    }
	    return SigningObject;
	}());
	exports.SigningObject = SigningObject;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var signing_process_1 = __webpack_require__(30);
	var filled_signing_object_1 = __webpack_require__(27);
	var signing_object_1 = __webpack_require__(28);
	/**
	 * @export
	 * @class RequestSigner
	 */
	var RequestSigner = /** @class */ (function () {
	    /**
	     * Creates an instance of RequestSigner.
	     * @param {WebApiClient} client
	     * @param {string} url
	     *
	     * @memberOf RequestSigner
	     */
	    function RequestSigner(client, url) {
	        var _this = this;
	        /**
	         * Obtains current signing info with full details from the API.
	         * @param {string} signId
	         * @param {Signable} order
	         *
	         * @memberOf RequestSigner
	         */
	        this.getSigningInfo = function (signId, order) {
	            return _this.client.callApi(_this.url + "/sign/" + signId, 'GET')
	                .then(function (response) {
	                var filled = new filled_signing_object_1.FilledSigningObject(response, _this.client, _this.url, order);
	                // update signInfo property on order to FilledSigningObject
	                order.signing = filled;
	                return filled;
	            });
	        };
	        /**
	         * Starts signing process with TAC (that usually means signing using OneTimePassword from SMS)
	         * This method will inform the API that the client will sign using TAC.
	         * @param {string} signId
	         * @returns {Promise<TacSigningProcess>}
	         *
	         * @memberOf RequestSigner
	         */
	        this.startSigningWithTac = function (signId) {
	            return _this.client.callApi(_this.url + "/sign/" + signId, 'POST', null, { authorizationType: 'TAC' })
	                .then(function (response) {
	                var signingObject = new signing_object_1.SigningObject(response, _this.client, _this.url);
	                return new signing_process_1.TacSigningProcess(_this, signingObject);
	            });
	        };
	        /**
	         * Starts signing process with CASE_MOBILE (that usually means signing using OneTimePassword from SMS)
	         * This method will inform the API that the client will sign using CASE_MOBILE.
	         * @param {string} signId
	         * @returns {Promise<CaseMobileSigningProcess>}
	         *
	         * @memberOf RequestSigner
	         */
	        this.startSigningWithCaseMobile = function (signId) {
	            return _this.client.callApi(_this.url + "/sign/" + signId, 'POST', null, { authorizationType: 'CASE_MOBILE' })
	                .then(function (response) {
	                var signingObject = new signing_object_1.SigningObject(response, _this.client, _this.url);
	                return new signing_process_1.CaseMobileSigningProcess(_this, signingObject);
	            });
	        };
	        /**
	         * Starts signing process with NO_AUTHORIZATION (that usually means signing the order just by clicking some button in UI)
	         * This method signalizes the intent to the API that this order will be signed using NO_AUTHORIZATION method
	         * @param {string} signId
	         * @returns {Promise<NoAuthSigningProcess>}
	         *
	         * @memberOf RequestSigner
	         */
	        this.startSigningWithNoAuthorization = function (signId) {
	            return _this.client.callApi(_this.url + "/sign/" + signId, 'POST', null, { authorizationType: 'NO_AUTHORIZATION' })
	                .then(function (response) {
	                var signingObject = new signing_object_1.SigningObject(response, _this.client, _this.url);
	                return new signing_process_1.NoAuthSigningProcess(_this, signingObject);
	            });
	        };
	        /**
	         * Finishes signing process with TAC (that usually means signing using OneTimePassword from SMS)
	         * You can call this method only if you successfully called `startSigningWithTAC` before.
	         * @param {string} oneTimePassword
	         * @param {string} signId
	         * @returns {Promise<SigningObject>}
	         *
	         * @memberOf RequestSigner
	         */
	        this.finishSigningWithTac = function (oneTimePassword, signId) { return _this.client.callApi(_this.url + "/sign/" + signId, 'PUT', null, { authorizationType: 'TAC', oneTimePassword: oneTimePassword }).then(function (response) { return new signing_object_1.SigningObject(response, _this.client, _this.url); }); };
	        /**
	         * Finishes signing process with CASE_MOBILE (that usually means signing using OneTimePassword from SMS)
	         * You can call this method only if you successfully called `startSigningWithCaseMobile` before.
	         * @param {string} oneTimePassword
	         * @param {string} signId
	         * @returns {Promise<SigningObject>}
	         *
	         * @memberOf RequestSigner
	         */
	        this.finishSigningWithCaseMobile = function (oneTimePassword, signId) { return _this.client.callApi(_this.url + "/sign/" + signId, 'PUT', null, { authorizationType: 'CASE_MOBILE', oneTimePassword: oneTimePassword }).then(function (response) { return new signing_object_1.SigningObject(response, _this.client, _this.url); }); };
	        /**
	         * This method signalizes the API that the user confirmed signing the order by consent (usually by clicking some button in the UI).
	         * You can call this method only if you successfully called `startSigningWithNoAuthorization` before.
	         * @param {string} signId
	         * @returns {Promise<SigningObject>}
	         *
	         * @memberOf RequestSigner
	         */
	        this.finishSigningWithNoAuth = function (signId) { return _this.client.callApi(_this.url + "/sign/" + signId, 'PUT', null, { authorizationType: 'NO_AUTHORIZATION' }).then(function (response) { return new signing_object_1.SigningObject(response, _this.client, _this.url); }); };
	        this.client = client;
	        this.url = url;
	    }
	    return RequestSigner;
	}());
	exports.RequestSigner = RequestSigner;


/***/ }),
/* 30 */
/***/ (function(module, exports) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 *
	 *
	 * @export
	 * @class SigningProcess
	 */
	var SigningProcess = /** @class */ (function () {
	    /**
	     * Creates an instance of SigningProcess.
	     * @param {RequestSigner} requestSigner
	     * @param {SigningObject} signingObject
	     *
	     * @memberOf SigningProcess
	     */
	    function SigningProcess(requestSigner, signingObject) {
	        this.requestSigner = requestSigner;
	        this.signingObject = signingObject;
	    }
	    return SigningProcess;
	}());
	exports.SigningProcess = SigningProcess;
	/**
	 * @export
	 * @class TacSigningProcess
	 * @extends {SigningProcess}
	 */
	var TacSigningProcess = /** @class */ (function (_super) {
	    __extends(TacSigningProcess, _super);
	    /**
	     * Creates an instance of TacSigningProcess.
	     * @param {RequestSigner} requestSigner
	     * @param {SigningObject} signingObject
	     *
	     * @memberOf TacSigningProcess
	     */
	    function TacSigningProcess(requestSigner, signingObject) {
	        var _this = _super.call(this, requestSigner, signingObject) || this;
	        /**
	         * Finishes signing process with TAC (that usually means signing using OneTimePassword from SMS)
	         * You can call this method only if you successfully called `startSigningWithTac` before.
	         * @param {string} oneTimePassword
	         * @returns {Promise<SigningObject>}
	         *
	         * @memberOf TacSigningProcess
	         */
	        _this.finishSigning = function (oneTimePassword) { return _this.requestSigner.finishSigningWithTac(oneTimePassword, _this.signingObject.signId).then(function (signingObject) {
	            _this.signingObject.order.signing = signingObject;
	            return signingObject;
	        }); };
	        return _this;
	    }
	    return TacSigningProcess;
	}(SigningProcess));
	exports.TacSigningProcess = TacSigningProcess;
	/**
	 * @export
	 * @class CaseMobileSigningProcess
	 * @extends {SigningProcess}
	 */
	var CaseMobileSigningProcess = /** @class */ (function (_super) {
	    __extends(CaseMobileSigningProcess, _super);
	    /**
	     * Creates an instance of CaseMobileSigningProcess.
	     * @param {RequestSigner} requestSigner
	     * @param {SigningObject} signingObject
	     *
	     * @memberOf CaseMobileSigningProcess
	     */
	    function CaseMobileSigningProcess(requestSigner, signingObject) {
	        var _this = _super.call(this, requestSigner, signingObject) || this;
	        /**
	         * Finishes signing process with CASE_MOBILE (that usually means signing using OneTimePassword from SMS)
	         * You can call this method only if you successfully called `startSigningWithCaseMobile` before.
	         * @param {string} oneTimePassword
	         * @returns {Promise<SigningObject>}
	         *
	         * @memberOf CaseMobileSigningProcess
	         */
	        _this.finishSigning = function (oneTimePassword) { return _this.requestSigner.finishSigningWithCaseMobile(oneTimePassword, _this.signingObject.signId).then(function (signingObject) {
	            _this.signingObject.order.signing = signingObject;
	            return signingObject;
	        }); };
	        return _this;
	    }
	    return CaseMobileSigningProcess;
	}(SigningProcess));
	exports.CaseMobileSigningProcess = CaseMobileSigningProcess;
	/**
	 * @export
	 * @class NoAuthSigningProcess
	 * @extends {SigningProcess}
	 */
	var NoAuthSigningProcess = /** @class */ (function (_super) {
	    __extends(NoAuthSigningProcess, _super);
	    /**
	     * Creates an instance of NoAuthSigningProcess.
	     * @param {RequestSigner} requestSigner
	     * @param {SigningObject} signingObject
	     *
	     * @memberOf NoAuthSigningProcess
	     */
	    function NoAuthSigningProcess(requestSigner, signingObject) {
	        var _this = _super.call(this, requestSigner, signingObject) || this;
	        /**
	         * Finishes signing process using NO_AUTHORIZATION method
	         * You can call this method only if you successfully called `startSigningWithNoAuthorization` before.
	         * @returns {Promise<FilledSigningObject>}
	         *
	         * @memberOf NoAuthSigningProcess
	         */
	        _this.finishSigning = function () { return _this.requestSigner.finishSigningWithNoAuth(_this.signingObject.signId).then(function (signingObject) {
	            _this.signingObject.order.signing = signingObject;
	            return signingObject;
	        }); };
	        return _this;
	    }
	    return NoAuthSigningProcess;
	}(SigningProcess));
	exports.NoAuthSigningProcess = NoAuthSigningProcess;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var error_1 = __webpack_require__(2);
	var signing_object_1 = __webpack_require__(28);
	/**
	 * @export
	 * @class SigningUtils
	 */
	var SigningUtils = /** @class */ (function () {
	    function SigningUtils() {
	    }
	    /**
	     * Replaces order's signInfo property with new SigningObject with passed parameters
	     *
	     * @static
	     * @param {any} order
	     * @param {WebApiClient} client
	     * @param {string} url
	     * @returns {void}
	     *
	     * @memberOf SigningUtils
	     */
	    SigningUtils.createSigningObject = function (order, client, url) {
	        if (!order || !order.signInfo) {
	            return;
	        }
	        if (!client) {
	            throw new error_1.ConfigurationError('You must pass client to createSigningObject function to have the ability to call API');
	        }
	        if (!url) {
	            throw new error_1.ConfigurationError('You must pass url for signing to createSigningObject function');
	        }
	        order.signing = new signing_object_1.SigningObject(order, client, url);
	        delete order.signInfo;
	    };
	    return SigningUtils;
	}());
	exports.SigningUtils = SigningUtils;


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// cs-core-sdk.node.min.js